import { createSelector } from "reselect";

import { RootState } from "redux/reducers/rootReducer";

const getReservationState = (state: RootState) => state.reservation;

export const getReservation = createSelector(
  [getReservationState],
  (state) => state
);

export const getReservationStatus = createSelector(
  [getReservationState],
  (state) => state.status
);

export const getCartId = createSelector(
  [getReservationState],
  (state) => state.cartId
);

export const getPendingMenuItem = createSelector(
  [getReservationState],
  (state) => state.pendingMenuItem
);

export const getCartItemCount = createSelector([getReservationState], (state) =>
  state?.cart?.cartItems?.reduce((count, item) => count + item.quantity, 0)
);

export const getStaleCartDispensaryInformation = createSelector(
  [getReservationState],
  (state) => state.cart?.dispensary
);

export const getLastItemAddedToBag = createSelector(
  [getReservationState],
  (state) =>
    state.justAddedVariantId &&
    state.cart?.cartItems?.find(
      (ci) => ci.variantId === state.justAddedVariantId
    )
);

export const getShowingAddedToBagPopover = createSelector(
  [getLastItemAddedToBag],
  (lastItemInBag) => !!lastItemInBag
);

export const isJaneCheckoutEnabled = createSelector(
  [getReservationState],
  (state) => state.janeCheckoutEnabled
);
